import React from 'react';
import './Loader.scss'; // Optional CSS for styling the loader

const Loader = () => (
    <div class="drawing" id="loading">
    <div class="loading-dot"></div>
  </div>
);

export default Loader;
